/**
 * media-query.js
 * Utilitaire pour détecter et réagir aux media queries en JavaScript
 */

const MediaQuery = {
  // Points de rupture correspondant à Bootstrap
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },

  /**
   * Vérifie si la largeur actuelle de la fenêtre est inférieure à un breakpoint
   * @param {string} breakpoint - Le nom du breakpoint (xs, sm, md, lg, xl)
   * @returns {boolean}
   */
  isDown(breakpoint) {
    const width = window.innerWidth;
    const breakpointValue = this.breakpoints[breakpoint];

    if (breakpoint === 'xs') {
      return width < this.breakpoints.sm;
    }

    const nextBreakpoint = Object.keys(this.breakpoints).find(key => 
      this.breakpoints[key] > breakpointValue
    );

    return width < this.breakpoints[nextBreakpoint];
  },

  /**
   * Vérifie si la largeur actuelle de la fenêtre est supérieure ou égale à un breakpoint
   * @param {string} breakpoint - Le nom du breakpoint (xs, sm, md, lg, xl)
   * @returns {boolean}
   */
  isUp(breakpoint) {
    return window.innerWidth >= this.breakpoints[breakpoint];
  },

  /**
   * Vérifie si la largeur actuelle de la fenêtre est entre deux breakpoints
   * @param {string} minBreakpoint - Le nom du breakpoint minimum (xs, sm, md, lg)
   * @param {string} maxBreakpoint - Le nom du breakpoint maximum (sm, md, lg, xl)
   * @returns {boolean}
   */
  isBetween(minBreakpoint, maxBreakpoint) {
    return this.isUp(minBreakpoint) && this.isDown(maxBreakpoint);
  },

  /**
   * Exécute une fonction lorsqu'un media query correspond
   * @param {string} query - La requête media (ex: '(max-width: 768px)')
   * @param {Function} callback - La fonction à exécuter
   * @returns {MediaQueryList} L'objet MediaQueryList
   */
  addListener(query, callback) {
    const mq = window.matchMedia(query);
    mq.addListener(callback);
    callback(mq);
    return mq;
  },

  /**
   * Initialise des callbacks pour différents breakpoints
   * @param {Object} callbacks - Un objet avec les callbacks pour chaque breakpoint
   */
  init(callbacks = {}) {
    if (callbacks.xs) {
      this.addListener(`(max-width: ${this.breakpoints.sm - 1}px)`, callbacks.xs);
    }
    if (callbacks.sm) {
      this.addListener(`(min-width: ${this.breakpoints.sm}px) and (max-width: ${this.breakpoints.md - 1}px)`, callbacks.sm);
    }
    if (callbacks.md) {
      this.addListener(`(min-width: ${this.breakpoints.md}px) and (max-width: ${this.breakpoints.lg - 1}px)`, callbacks.md);
    }
    if (callbacks.lg) {
      this.addListener(`(min-width: ${this.breakpoints.lg}px) and (max-width: ${this.breakpoints.xl - 1}px)`, callbacks.lg);
    }
    if (callbacks.xl) {
      this.addListener(`(min-width: ${this.breakpoints.xl}px)`, callbacks.xl);
    }
  }
};

export default MediaQuery;
